<p-progressSpinner [animationDuration]="'1s'"
                   [style]="{width: spinnerWidth, height: spinnerHeight}"
                   styleClass="custom-spinner"
                   [strokeWidth]="strokeWidth"
                   [fill]="fillColor"
                   animationDuration="1s"></p-progressSpinner>
